module.exports = __webpack_public_path__ + "static/media/watania_university_logo.7ebb9b24.jpg";